import Dashboard from '@/components/Music/Dashboard.vue'
import EventPlanner from '@/components/Music/EventPlanner.vue'
import SpotifyCallback from '@/components/Music/SpotifyCallback.vue'
import MusicLogin from '@/components/Music/MusicLogin.vue'
import Analytics from '@/components/Music/Analytics.vue'
import ArtistDetail from '@/components/Music/ArtistDetail.vue'
import GenreDetail from '@/components/Music/GenreDetail.vue'
import MyPlaylists from '@/components/Music/MyPlaylists.vue'
import AllArtists from '@/components/Music/AllArtists.vue'
import MissingMbArtists from '@/components/Music/MissingMbArtists.vue'
import AllGenres from '@/components/Music/AllGenres.vue'

export default [
    {
        path: '/',
        name: 'music_dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/events',
        name: 'music_events',
        component: EventPlanner,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics',
        name: 'music_analytics',
        component: Analytics,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics/artist/:id',
        name: 'music_artist_detail',
        component: ArtistDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics/genre/:id',
        name: 'music_genre_detail',
        component: GenreDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics/playlists',
        name: 'music_my_playlists',
        component: MyPlaylists,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics/artists',
        name: 'music_all_artists',
        component: AllArtists,
        meta: { requiresAuth: true }
    },
    {
        path: '/analytics/artists/missing-mbid',
        name: 'MissingMbArtists',
        component: MissingMbArtists,
        meta: { requiredRole: 'ROLE_USER' }
    },
    {
        path: '/analytics/genres',
        name: 'music_all_genres',
        component: AllGenres,
        meta: { requiresAuth: true }
    },
    {
        path: '/spotify-callback',
        name: 'music_spotify_callback',
        component: SpotifyCallback,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'music_login',
        component: MusicLogin,
        meta: { requiresAuth: false }
    }
]
